import React, { type ReactElement } from 'react';

import Head from 'next/head';

import Layout from '@client/components/layout';
import SomethingWentWrong from '@client/components/layout/components/SomethingWentWrong';
import ProtectedRoute from '@client/context/auth/ProtectedRoute';
import { BootIntercom } from '@client/helpers/intercom/bootIntercom';

import { type NextPageWithLayout } from './_app';

const Custom404: NextPageWithLayout = () => (
  <>
    <Head>
      <title>404 - Something went wrong</title>
    </Head>
    <SomethingWentWrong />
  </>
);

Custom404.getLayout = (page: ReactElement) => (
  <ProtectedRoute>
    <BootIntercom>
      <Layout>{page}</Layout>
    </BootIntercom>
  </ProtectedRoute>
);

export default Custom404;
